<template>
  <el-container class="login-container">
    <div class="QRcodeMain">
      <div class="cardHeader">
        <img src="../../assets/zqx.png" alt="" srcset="" style="width: 40px; height: 40px;">
        足球行经销商管理系统
      </div>
      <div class="cardBody">
        <div class="newsArea">
          <img src="../../assets/xieuxiaoguanl.png" alt="" style="width: 200px;height: 250px;">
        </div>
        <div class="QRcode">
          <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="账号：" prop="username">
              <el-input v-model="form.username" maxlength="18" placeholder="请输入账号"></el-input>
            </el-form-item>
            <div style="width: 100%;height: 20px;"></div>
            <el-form-item label="密码：" prop="password">
              <el-input v-model="form.password" maxlength="18" placeholder="请输入密码" show-password></el-input>
            </el-form-item>
            <div class="QRcodeFoot">
              <el-button class="QRcodeFootBtn" type="primary" @click="handleLogin('ruleForm')" :loading="loading">登录</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <div class="footerRow">
      <div>开发单位：合肥足行体育科技有限公司</div>
      <!--      <div style="margin: 5px 0">备案号</div>-->
    </div>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
      loading: false
    };
  },
  mounted() {
  },
  methods: {
    handleLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          // 模拟异步操作
          setTimeout(() => {
            // 设置模拟token和用户信息
            localStorage.setItem('Authorization', 'mock-token-123456');
            localStorage.setItem('user_info', JSON.stringify({
              username: 'admin',
              name: '测试用户'
            }));

            this.$router.push('/');
            this.$message.success('模拟登录成功');
            this.loading = false;
          }, 800);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>
<!-- <script src="https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js">
</script>
<script>
!function (a, b, c) {
  function d (a) {
    var c = "default"
    a.self_redirect === !0 ? c = "true" : a.self_redirect === !1 && (c = "false")
    var d = b.createElement("iframe"),
      e = "https://open.weixin.qq.com/connect/qrconnect?appid=" + a.appid + "&scope=" + a.scope + "&redirect_uri=" + a.redirect_uri + "&state=" + a.state + "&login_type=jssdk&self_redirect=" + c + '&styletype=' + (a.styletype || '') + '&sizetype=' + (a.sizetype || '') + '&bgcolor=' + (a.bgcolor || '') + '&rst=' + (a.rst || '')
    e += a.style ? "&style=" + a.style : "",
      e += a.href ? "&href=" + a.href : "",
      d.src = e,
      d.frameBorder = "0",
      d.allowTransparency = "true",
      d.sandbox = "allow-scripts allow-top-navigation allow-same-origin", //重点
      d.scrolling = "no",
      d.width = "300px",
      d.height = "400px"
    var f = b.getElementById(a.id)
    f.innerHTML = "",
      f.appendChild(d)
  }
  a.WxLogin = d
}(window, document);
export default {
  data() {
    return {
    };
  },
  mounted() {
    // this.createWxQrcode();
    this.getCodeMes();
  },
  methods: {
    getCodeMes() {
      let code = this.getQueryString("code");
      console.log("地址中的code:", code);
      if (!code) {
        this.createWxQrcode();
      } else {
        this.getLoginMes(code);
      }
    },

    //使用正则读取url里的code
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      // console.log(window.location.search);
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return "";
    },

    async getLoginMes(code) {
      this.$router.push('/');
      this.$message.success('模拟登录成功');
      console.log('通过返回的code获取后台token:', code);
      // const { res } = await this.$http.get(`/AdminUser/MatchOrgCheckLogin?code=${code}`);
      // if (res.isSuccess) {
      //   localStorage.setItem('Authorization', res.data.token);
      //   localStorage.setItem('user_info', JSON.stringify(res.data.info));
      //
      //   this.$http.get('/Match/GetMatchPageList').then(response => {
      //     if (response.res.isSuccess) {
      //       const matchList = response.res.data || [];
      //       if (matchList.length) {
      //         localStorage.setItem('matchId', matchList[0].matchId);
      //         localStorage.setItem('currentMatchId', JSON.stringify(matchList[0]));
      //       }
      //       location.reload();
      //     }
      //   });
      // }else{
      //   this.createWxQrcode()
      // }
    },

    createWxQrcode() {
      // 生成微信登录二维码
      var obj = new WxLogin({
        self_redirect: false,
        id: "weixin", // 页面显示二维码的容器id
        appid: "wx6b5cd40af3b86494", // 微信官方提供的测试id
        scope: "snsapi_login",
        //  redirect_uri: encodeURI("http://saishi.ladesports.com/logindev/login"), // 微信官方中的测试环境url地址
        redirect_uri: encodeURI("http://saishi.ladesports.com/login"), // 微信官方中的测试环境url地址
        state: "bind",
        style: "black",
        secret:"c0ce602f247cace43a0744c1e473b7e6",
        href: "",
      });
    },
    handleLogin() {
      // 本地验证逻辑
      if (this.form.username === 'admin' && this.form.password === '123456') {
        this.loading = true;

        // 模拟异步操作
        setTimeout(() => {
          // 设置模拟token和用户信息
          localStorage.setItem('Authorization', 'mock-token-123456');
          localStorage.setItem('user_info', JSON.stringify({
            username: 'admin',
            name: '测试用户'
          }));

          this.$router.push('/');
          this.$message.success('模拟登录成功');
          this.loading = false;
        }, 800);
      } else {
        this.$message.error('账号或密码错误（测试账号：admin/123456）');
      }
    }
  }
};
</script> -->

<style lang="scss" scoped>
/* 保持原有样式不变 */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  //background: url(https://x-ai.oss-cn-hangzhou.aliyuncs.com/2025.4.24/beijing.png) no-repeat center/cover;
  background: url(../../assets/mazhuolainm.jpg) no-repeat center/cover;
}
.QRcodeMain {
  position: absolute;
  width: auto;
  //height: 450px;
  margin: 0 auto;
  border-radius: 25px;
  background: rgba(239, 244, 255, 0.8);
}
.cardHeader{
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: black;
}
.cardBody{
  display: flex;
  align-items: center;
  justify-content: center;
}

.QRcode {
  width: 350px;
  height: 100%;
  padding: 20px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border-radius: 5px;
  display: flex;
}

.newsArea {
  width: 350px;
  height: 100%;
  padding: 20px;
  //margin-top: 30px;
  //border-right: 1px solid #eeeeee;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footerRow{
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
